import { FormattedMessage } from 'react-intl'
import SpreadsheetTable from '@components/SpreadsheetTable/SpreadsheetTable'
import { useDataset } from '@hooks/useCatalog'
import { DataRow } from 'src/types/tableDataSet'

import './SampleData.css'

interface SampleDataProps {
  id: string
}

export default function SampleData({ id }: SampleDataProps) {
  const { sampleData, colSpec } = useDataset(id)

  if (sampleData.length === 0) {
    return (
      <div id="sample-data">
        <FormattedMessage id="dataset.table-data.empty" />
      </div>
    )
  }

  const rows: DataRow[] = sampleData.map((row) =>
    colSpec.map((col) => row[col.name] ?? null)
  )

  return (
    <div id="sample-data">
      <h2>
        <FormattedMessage id="dataset.table-data.title" />
      </h2>

      <div className="table-wrapper-simple">
        <SpreadsheetTable
          columnsDef={colSpec}
          rows={rows}
          pageSize={20}
          currentPage={0}
          idColumnIndex={0}
          cornerHeader="#"
        />
      </div>
    </div>
  )
}
